export const PARTS_3D_MATCH_THRESHOLD = 0.7;

export function isPartsSectionLoading({
  dpmType,
  gltfResolved,
  gltfUrl,
  partsMetadata,
  modelLoaded,
}) {
  if (dpmType === null) return true;
  if (dpmType !== "3d") return false;
  if (!gltfResolved) return true;
  if (gltfUrl == null) return false;
  return !(partsMetadata != null && modelLoaded);
}

export function getPart3DMeta(part, partsMetadata) {
  if (part?.id == null || !partsMetadata) return null;
  return partsMetadata[part.id] ?? null;
}

export function partHas3DMatch(part, partsMetadata) {
  return Boolean(getPart3DMeta(part, partsMetadata)?.full_path);
}

export function resolvePartsView({ items, partsMetadata, modelReady }) {
  const matched = items.filter(part => partHas3DMatch(part, partsMetadata)).length;
  const enoughMatches =
    items.length > 0 && matched / items.length >= PARTS_3D_MATCH_THRESHOLD;

  return modelReady && enoughMatches ? "grid" : "list";
}
